import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  public subscriptionForm: FormGroup;
  constructor(private toastr: ToastrService,
    private titleService: Title,
    private metaService: Meta) { 
    this.subscriptionForm = new FormGroup({
      email: new FormControl(null, Validators.required),
    });
  }

  ngOnInit() {
    this.setSEOData();
  }

  setSEOData(): void {
   

    let aboutDescription = `About EWNS, Custom Ecommerce platform to meet all your digital needs, Enable social commerce and Ecommerce in matter of minutes, Create and manage website from anywhere on any device, Enable digital commerce for your business`;

    this.titleService.setTitle(aboutDescription);

    this.metaService.addTag({name: 'name', content: aboutDescription});
    this.metaService.addTag({name: 'description', content: aboutDescription});
    this.metaService.addTag({name: 'image', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})
    this.metaService.addTag({name: 'logo', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})
    this.metaService.addTag({name: 'keywords', content: aboutDescription})


    this.metaService.addTag({name: 'twitter:card', content: 'product'});
    this.metaService.addTag({name: 'twitter:title', content: aboutDescription});
    this.metaService.addTag({name: 'twitter:description', content: aboutDescription});
    this.metaService.addTag({name: 'twitter:image', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})


    //OG GRAPH DATA
    this.metaService.addTag({name: 'og:type', content: 'article'});
    this.metaService.addTag({name: 'og:site_name', content: 'EWNS'});
    this.metaService.addTag({name: 'og:url', content: "https://ewns.in"});
    this.metaService.addTag({name: 'og:description', content: aboutDescription});
    this.metaService.addTag({name: 'og:image', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})
  }

  subscribe(){
    const {email} = this.subscriptionForm.value;
    if(email == "" || email == undefined || email == null)
    {
      this.toastr.error("Email cannot be empty", "Subscription");
    }
    else{
      this.toastr.success("Thanks for reaching us, our team will get back to you soon", "Subscription");
    }
      
  }

}
